import React, { createContext, useContext, useState } from 'react';
import AuthManager from "../../../../../Common/AuthManager";

type ViewType = 'list' | 'editor';

type ModuleContextType = {
  activeView: ViewType;
  setActiveView: (view: ViewType) => void;
  industryId: string;
  userId: string;
  hasEditPermission: () => boolean;
}

const ModuleContext = createContext<ModuleContextType | undefined>(undefined);

export const ModuleProvider: React.FC<{ children: React.ReactNode; industryId?: string; userId?: string }> = ({
  children, 
  industryId = '',
  userId = ''
}) => {
  const [activeView, setActiveView] = useState<ViewType>('list');
  const hasEditPermission = () => userId === AuthManager.getAuthUser().profile?.id;
  return (
    <ModuleContext.Provider 
      value={{ 
        activeView, 
        setActiveView,
        industryId,
        userId,
        hasEditPermission
      }}
    >
      {children}
    </ModuleContext.Provider>
  );
};

export const useModule = () => {
  const context = useContext(ModuleContext);
  if (context === undefined) {
    throw new Error('useModule must be used within a ModuleProvider');
  }
  return context;
};